import { __decorate } from "tslib";
import { Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { Api } from '@/domains/api';
let WarningStore = class WarningStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.allWarnings = [];
    }
    get warning() {
        return (controller) => {
            const filterd = this.allWarnings.find((w) => {
                return w.controller.id === controller.id;
            });
            if (filterd === undefined) {
                return [];
            }
            return filterd.warnings;
        };
    }
    async fetch() {
        try {
            const response = await Api.Warnings.GetAll();
            return {
                allWarnings: response.data,
            };
        }
        catch {
            return {
                allWarnings: [],
            };
        }
    }
};
__decorate([
    MutationAction({ mutate: ['allWarnings'] })
], WarningStore.prototype, "fetch", null);
WarningStore = __decorate([
    Module({
        namespaced: true,
    })
], WarningStore);
export default WarningStore;
export * from './type';
